import React from "react";
import "./SellerAbouttawq.css";

export default function SellerAbouttawq() {
  return (
    <div className="about-wrapper">
      <div className="container">

        <h1 className="about-title">عن طوق نجاة</h1>

        <div className="about-card">

          <h2>من نحن؟</h2>
          <p>
            طوق نجاة هو منصة تسوق إلكترونية تهدف إلى تسهيل عملية البيع والشراء في
            مكان واحد آمن وسهل الاستخدام. نسعى إلى ربط البائع بالمشتري بكل شفافية
            وسرعة.
          </p>

          <h2>رؤيتنا</h2>
          <p>
            أن نكون الوجهة الأولى للتسوق الإلكتروني الموثوق في الوطن العربي.
          </p>

          <h2>رسالتنا</h2>
          <p>
            تقديم تجربة تسوق مريحة، منتجات متنوعة، وأسعار تنافسية مع دعم فني دائم.
          </p>

          <h2>لماذا طوق نجاة؟</h2>
          <ul>
            <li>✅ تنوع كبير في المنتجات</li>
            <li>✅ بائعين موثوقين</li>
            <li>✅ طرق دفع آمنة</li>
            <li>✅ دعم فني سريع</li>
          </ul>

        </div>

      </div>
    </div>
  );
}
